import SiteNav from '@/components/feature/SiteNav';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoriesSection from '@/pages/home/components/CategoriesSection';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import LatestSection from '@/pages/home/components/LatestSection';
import DeepDiveSection from '@/pages/home/components/DeepDiveSection';
import FaqSection from '@/pages/home/components/FaqSection';
import AboutSection from '@/pages/home/components/AboutSection';
import SubscriptionSection from '@/pages/home/components/SubscriptionSection';
import StructuredData from '@/pages/home/components/StructuredData';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <StructuredData />
      <SiteNav />
      <main>
        <HeroSection />
        <CategoriesSection />
        <FeaturedSection />
        <LatestSection />
        <DeepDiveSection />
        <FaqSection />
        <AboutSection />
        <SubscriptionSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}